/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { IVCSStrictHttpResponse } from '../../ivcs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Pharmacist } from '../../models/pharmacist';

export interface ConsumerUpdatePharmacistPost$Plain$Params {
      body?: Pharmacist
}

export function consumerUpdatePharmacistPost$Plain(http: HttpClient, rootUrl: string, params?: ConsumerUpdatePharmacistPost$Plain$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<Pharmacist>> {
  const rb = new RequestBuilder(rootUrl, consumerUpdatePharmacistPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as IVCSStrictHttpResponse<Pharmacist>;
    })
  );
}

consumerUpdatePharmacistPost$Plain.PATH = '/Consumer/UpdatePharmacist';
